module.exports = __webpack_public_path__ + "assets/img/main-top-achievements-ada-mobile.892a6a71.svg";